module.exports = __webpack_public_path__ + "static/img/27.4be4fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/27.png
// module id = hEZz
// module chunks = 0